import React from "react";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";

const borderColor = "#AAAAAA";
const specialBorderColor = "#F3F3F4";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#F45B69",
    color: theme.palette.common.white,
    fontWeight: 700,
    border: `1px solid ${borderColor}`,
    verticalAlign: "baseline",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    color: "#555555",
    border: `1px solid ${borderColor}`,
    verticalAlign: "baseline",
  },
  "&.bold-text": {
    fontWeight: 700,
  },
  "&:first-child": {
    borderLeft: `1px solid ${specialBorderColor}`,
  },
  "&:last-child": {
    borderRight: `1px solid ${specialBorderColor}`,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: "#CCE5E5",
  },
}));

const AnnexureTable = ({ isBold = false, tableHeader, rows }) => {
  return (
    <TableContainer>
      <Table aria-label="customized table">
        <TableHead>
          <TableRow>
            {tableHeader &&
              tableHeader.map((elem) => {
                return <StyledTableCell>{elem}</StyledTableCell>;
              })}
          </TableRow>
        </TableHead>
        <TableBody>
          {rows &&
            rows.map((row) => (
              <StyledTableRow key={row.sno}>
                <StyledTableCell component="th" scope="row">
                  {row.sno && row.sno}
                </StyledTableCell>
                <StyledTableCell className={isBold && "bold-text"}>
                  {row.data1 && row.data1}
                </StyledTableCell>
                <StyledTableCell>{row.data2 && row.data2}</StyledTableCell>
                <StyledTableCell>{row.data3 && row.data3}</StyledTableCell>
                {row.data4 && <StyledTableCell>{row.data4}</StyledTableCell>}
                {row.data5 && (
                  <StyledTableCell>{row.data5 && row.data5}</StyledTableCell>
                )}
                {row.data6 && (
                  <StyledTableCell>{row.data6 && row.data6}</StyledTableCell>
                )}
                {row.data7 && (
                  <StyledTableCell>{row.data7 && row.data7}</StyledTableCell>
                )}
                {row.data8 && (
                  <StyledTableCell>{row.data8 && row.data8}</StyledTableCell>
                )}
                {row.data9 && (
                  <StyledTableCell>{row.data9 && row.data9}</StyledTableCell>
                )}
              </StyledTableRow>
            ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default AnnexureTable;
